import React, { Component } from 'react'
import { connect } from 'react-redux'
import Loader from 'components/loader/loader'
import Icon from 'components/icon/icon'
import Button from 'components/button/button'

import StatusProgress from './status-progress'
import StatusPlan from './status-plan'
import StatusHelp from './status-help'
import StatusClose from './status-close'
import StatusBilling from './status-billing'
import StatusInvoices from './status-invoices'

import { API_URL } from 'state/api'

import MobileSubMenu from 'components/mobile/mobile-sub-menu'

import moment from 'moment'

import {
	getCurrentAccount,
	getCurrentUser,
	getAccountProjects
} from 'state/selectors'

import {
	openModal,
	getInvoices
} from 'state/actions'

class Status extends Component {
	UNSAFE_componentWillMount() {
		const {
			getInvoices,
			accountData,
		} = this.props

		getInvoices(accountData)
	}
	
	editAccount = _ => {
		this.props.openModal('edit', 'settings', {
			type: 'account'
		})
	}

	exportProjects = _ => {
        const {
            accountData
        } = this.props

        const anchor = document.createElement('a')
        anchor.href = API_URL+'/accounts/'+accountData.id+'/exportProjects'

        document.body.appendChild(anchor)
        anchor.click()
        anchor.remove()
	}

	render() {
		const {
			accountData,
			accountProjects
		} = this.props

		let userCount = 0
		const guestCount = accountData.guestIds ? accountData.guestIds.length : 0
		const projectCount = accountProjects.length

		accountData.users.forEach(userId => {
			if(accountData.guestIds.indexOf(userId) == -1){
				return userCount++
			}
		})

		const mobilesubMenuOptions = [
			{
				icon: 'fe-edit-2',
				label: 'Organization settings',
				callback: this.editAccount
			},
		]

		if(accountData.id == 4848){
			mobilesubMenuOptions.push({
				icon: 'star-o',
				label: 'Export projects',
				callback: this.exportProjects
			})
		}

		return (
			<div className="page-container status-page">
				<header className="main-header no-border-bottom">
					<h1>
						{ accountData.name }
					</h1>
					<div className="sub-title-area">
						<span className="icons-list">
							<Icon name="building-o" />
							Joined { moment(accountData.created_at).format('Do MMMM, Y') }
							<Icon name="user-circle-o" />
							{ userCount } user{ userCount == 1 ? '' : 's' }
							{ guestCount ? 
								`, ${guestCount} guests`
								: null
							}
							<Icon name="star" />
							{ projectCount } project{ projectCount == 1 ? '' : 's' }
						</span>
					</div>
					<div className="button-area">
						{ (accountData.id == 4848 || accountData.id == 1) ?
						<Button 
							size="small" 
							label="Export projects" 
							icon="star-o" 
							callback={this.exportProjects} 
						/>
						: null }
						<Button 
							size="small" 
							label="Organisation settings" 
							icon="fe-edit-2" 
							callback={this.editAccount} 
						/>
					</div>
					<MobileSubMenu options={mobilesubMenuOptions} />
				</header>
				<div className="dashboard-container">
					<main className="clear">
						<div className="row">
							<div className="left-column">
								<StatusPlan />
								<StatusProgress 
									account={accountData}
									type="storage"
								/>
								{ !accountData.isPremium ?
									<StatusProgress
										account={accountData}
										type="projects"
									/>
								:
									<StatusBilling
										account={accountData}
									/>
								}
							</div>
							<div className="right-column">
								{ (accountData.invoices && accountData.invoices.length) ? 
									<StatusInvoices account={accountData} />
								: null }
								<StatusHelp />
								<StatusClose account={accountData} />
							</div>
						</div>
					</main>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		userData: getCurrentUser(state),
		accountData: getCurrentAccount(state),
		accountProjects: getAccountProjects(state)
	}
}

export default connect(mapStateToProps, {
	openModal,
	getInvoices
})(Status)